/** Shared allowlist; client evidence never establishes server/venue acceptance. */
export const POLY_ATTEMPT_HEADER = 'X-G1-Order-Attempt';
export const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
export type ClientAttemptStage = 'intent' | 'dispatched' | 'blocked' | 'response' | 'unknown';
export type ClientAttemptEvent = {
  eventId: string; attemptId: string; at: number; stage: ClientAttemptStage;
  market: string | null; status: number | null;
};
export function safeMarket(value: unknown): string | null {
  return typeof value === 'string' && /^[a-zA-Z0-9_.:-]{1,128}$/.test(value) ? value : null;
}
export function validClientAttempt(value: unknown): value is ClientAttemptEvent {
  if (!value || typeof value !== 'object') return false;
  const v = value as ClientAttemptEvent;
  return Object.keys(v).length === 6 && UUID.test(v.eventId) && UUID.test(v.attemptId)
    && Number.isSafeInteger(v.at) && v.at > 0
    && ['intent', 'dispatched', 'blocked', 'response', 'unknown'].includes(v.stage)
    && (v.market === null || safeMarket(v.market) === v.market)
    && (v.status === null || (Number.isInteger(v.status) && v.status >= 0 && v.status <= 599));
}
